import { useState } from "react";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

const PdfCard = ({ url, title }) => {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div className="pdf-card">
      <h3 className="pdf-card-title">{title}</h3>
      <div className="pdf-viewer-container">
        <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
          {/* Display the first page as a preview in the card */}
          {numPages && <Page pageNumber={1} renderTextLayer={false} />}
        </Document>
      </div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="pdf-link"
      >
        View Plan
      </a>
    </div>
  );
};

export default PdfCard;
